import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamMemberDetailsViewComponent } from './team-member-details-view/team-member-details-view/team-member-details-view.component';
import { DetailsViewContainerComponent } from './details-view-container/details-view-container/details-view-container.component';
import { OrgDetailsViewComponent } from './org-details-view/org-details-view/org-details-view.component';
import { TranslateModule } from '@ngx-translate/core';
import { MoovCommonModule } from '../moov-common/moov-common.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TextFieldModule } from '@angular/cdk/text-field';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MakeMoovModule } from '../make-moov/make-moov.module';
import { MatStepperModule } from '@angular/material/stepper';
import { TeamViewModule } from '../team-view/team-view.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [
    TeamMemberDetailsViewComponent,
    DetailsViewContainerComponent,
    OrgDetailsViewComponent
  ],
  imports: [
    CommonModule,
    MoovCommonModule,
    MatGridListModule,
    MatDialogModule,
    MatSidenavModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    MatButtonToggleModule,
    TextFieldModule,
    MatInputModule,
    FormsModule,
    MatTabsModule,
    MatDividerModule,
    MakeMoovModule,
    MatStepperModule,
    MatListModule,
    TeamViewModule
  ]
})
export class DetailsViewModule { }
